import React, { Component } from 'react'
import { painel, fieldset, Item, Input } from 'scorpion-core';
import EditorSeletor from '../../editor/SeletorUidCustomForm'
import Tabela from './Tabela'


import { Field } from 'redux-form';
function componentRelEspelho(comp, dados) {
    let listaColunas = [];

    listaColunas.push(comp.columns.map(c => {
        return [{ style: "cellTitulo", text: c.label }]
    }))

    return (fieldset(comp.label,
        painel([
            [{ style: "cellTitulo", text: comp.label }], [{ style: "cellValor", text: "Não implementado" }]
        ], { widths: ['*'] })
    ))

}

function component(item,propsview) {

    return (<Item key={item.sha} style={{ flex: 1 }}>
        <Field name={item.field} label={item.label}
            item={item} propsview={propsview} component={Tabela} />
    </Item>)
}

const modelo = {
    typeComponente: "TabelaItensCustomForm",
    field: "itens",
    label: "Tabela de Itens Custom",
    nomeItem: "Item",
    componentes: [
        { field: "nome", label: "Nome", typeComponente: "Input" },
        { field: "descricao", label: "Descrição", typeComponente: "Input", },
    ],
    customFormUid: "",


}
const comp = {
    typeComponente: "TabelaItensCustomForm",
    configView: {
        nome: "Tabela de Itens Custom",
        modelo,
        editores: {
            customFormUid: EditorSeletor
        },
    },
    componentRelEspelho,
    component
}



export default comp;


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/TabelaItensCustomForm/TabelaItensComp.js